import InputText from '../components/InputText.vue';
import InputPassword from '../components/InputPassword.vue';
import InputCheckbox from '../components/InputCheckbox.vue';
import InputCheckboxGroup from '../components/InputCheckboxGroup.vue';
import InputSplitCheckboxGroup from '../components/InputSplitCheckboxGroup.vue';
import InputRadio from '../components/InputRadio.vue';

export default {
  components: {
    InputText,
    InputPassword,
    InputCheckbox,
    InputCheckboxGroup,
    InputSplitCheckboxGroup,
    InputRadio,
  },
};



// WEBPACK FOOTER //
// ./src/mixins/form-elements.js